import type { ReactNode } from "react";
import { useApp } from "../data/StoreContext";
import { useAccountSheet } from "./accountSheetContext";
import { useLayoutMode } from "./useLayoutMode";

/** Page title; on phones it carries the account button (your initial) top right. */
export function PageHeader({ title, actions }: { title: string; actions?: ReactNode }) {
  const mode = useLayoutMode();
  const { session } = useApp();
  const openSheet = useAccountSheet();
  return (
    <header className="flex items-center gap-3 px-4 pt-4 pb-2.5 md:px-7 md:pt-6">
      <h1 className="m-0 min-w-0 flex-1 truncate text-[24px] font-extrabold">{title}</h1>
      {actions}
      {mode === "phone" && (
        <button
          type="button"
          onClick={openSheet}
          aria-label={`Account: ${session.displayName}`}
          className="grid size-11 shrink-0 place-items-center rounded-full bg-pos-bg text-[15px] font-extrabold text-pos"
        >
          {session.displayName.charAt(0).toUpperCase()}
        </button>
      )}
    </header>
  );
}
